import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/foodcourts',
    name: 'food-court',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/food-court/form.vue')
  },
  {
    path: '/foodcourts/:id',
    name: 'food-court-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/food-court/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('inventory/foodCourt/find', to.params.id)
      next()
    }
  }
]
